import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ProductionStatusService {

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    let roleIds = "-1";
    let employeeId = "-1";
    let languageId = "1", sessionId = "00000000-0000-0000-0000-000000000000";
    if (typeof (this.userService.account) !== 'undefined' && this.userService.account != null) {
      if (typeof (this.userService.account.RoleIds) !== 'undefined' && this.userService.account.RoleIds != null && this.userService.account.RoleIds.length > 0) {
        roleIds = this.userService.account.RoleIds.join(',');
      }
      if (typeof (this.userService.account.EmployeeId) !== 'undefined' && this.userService.account.EmployeeId > 0) {
        employeeId = this.userService.account.EmployeeId.toString();
      }

      if (typeof (this.userService.languageId) !== 'undefined' && this.userService.languageId != null) {
        languageId = this.userService.languageId.toString();
      }
      if (typeof (this.userService.sessionId) !== 'undefined' && this.userService.sessionId !== null) {
        sessionId = this.userService.sessionId;
      }
    }

    return {
      headers: new HttpHeaders({ 
        'Content-Type': 'application/json',
        'LanguageId': languageId,
        'SessionId': sessionId,
        'RoleIds': roleIds,
        'EmployeeId': employeeId,
      })
    };
  }

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) {
  }

  public getProductionStatusStuff(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetStuff`, this.httpOptions);
  }
  
  public getCustomReport1(reportReportElementId: number, showPublicly: boolean): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetCustomReport1?reportReportElementId=${reportReportElementId}&showPublicly=${showPublicly ? "true" : "false"}`, this.httpOptions);
  }

  public getProductionRawData(productionDataId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetProductionRawData?productionDataId=${productionDataId}`, this.httpOptions);
  }

  public getCustom1reportReportElements(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetReportReportElementsByCustomElementNumber?customElementNumber=1`, this.httpOptions);
  }

  getCustom2reportReportElements(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetReportsByCustomElementNumber?customElementNumber=2`, this.httpOptions);
  }

  public getProductionStatusReports(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetProductionStatusReports`, this.httpOptions);
  }

  public getProductionStatusReport(reportId:number): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetProductionStatusReport?reportId=${reportId}`, this.httpOptions);
  }

  public getCustomReport2(reportId: number, showPublicly: boolean): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetCustomReport2?reportId=${reportId}&showPublicly=${showPublicly ? "true" : "false"}`, this.httpOptions);
  }

  public getCustomReport2details(reportReportElementId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetCustomReport2Details?reportReportElementId=${reportReportElementId}`, this.httpOptions);
  }

  // admin

  public getReportReportElements(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetReportReportElements`, this.httpOptions);
  }

  public GetReportReportElementsByReport(reportId: any): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetReportReportElementsByReport?reportId=${reportId}`, this.httpOptions);
  }

  public getReportReportElement(id: any): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetReportReportElement?id=${id}`, this.httpOptions);
  }

  public getReportReportElementSequence(reportReportelementId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetReportReportElementSequence?reportReportElementId=${reportReportelementId}`, this.httpOptions);
  }

  public setReportReportElementSequence(reportReportelementId: number, sequence: string): Observable<any> {
    return this.http.post<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/SetReportReportElementSequence`, { reportReportelementId: reportReportelementId, sequence: sequence }, this.httpOptions);
  }

  public saveReportReportElement(viewModel: any): Observable<any> {
    return this.http.post(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/SaveReportReportElement`, viewModel, this.httpOptions);
  }

  public createCustomReport2(report: any): Observable<any> {
    return this.http.post(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/CreateCustomReport2`, report, this.httpOptions);
  }

  public getAddNewReportReportElements(reportId: any, numberOfElements: any, customElementNumber: any, columnCount: number): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetAddNewReportReportElements?reportId=${reportId}&numberOfElements=${numberOfElements}&customElementNumber=${customElementNumber}&columnCount=${columnCount}`, this.httpOptions);
  }

  public deleteReport(id: any): Observable<any> {
    return this.http.delete(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/deleteReport?id=${id}`, this.httpOptions);
  }
  public deleteReportReportElement(id: any): Observable<any> {
    return this.http.delete(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/DeleteReportReportElement?id=${id}`, this.httpOptions);
  }

  public getReportElements(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetReportElements`, this.httpOptions);
  }

  public saveReportElement(viewModel: any): Observable<any> {
    return this.http.post(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/SaveReportElement`, viewModel, this.httpOptions);
  }

  public deleteReportElement(id: any): Observable<any> {
    return this.http.delete(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/deleteReportElement?id=${id}`, this.httpOptions);
  }

  public getProductionGroups(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetProductionGroups`, this.httpOptions);
  }

  public saveProductionGroup(viewModel: any): Observable<any> {
    return this.http.post(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/SaveProductionGroup`, viewModel, this.httpOptions);
  }

  public deleteProductionGroup(id: any): Observable<any> {
    return this.http.delete(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/deleteProductionGroup?id=${id}`, this.httpOptions);
  }

  public getProductionLevel3s(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetProductionLevel3s`, this.httpOptions);
  }

  // public 

  public getPubliclyAvailableReports(): Observable<any> {
    return this.http.get<any>(this.configService.config.dataWarehouseUrl + `/api/ProductionStatus/GetPubliclyAvailableReports`, this.httpOptions);
  }

  public getLanguageTagTexts(languageId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.directUrl + `/api/Language/GetLanguageTagTexts?languageId=${languageId}`, this.httpOptions);
  }
}
